import React from "react";
import "./App.css";
import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { Route, Switch } from "react-router-dom";
import Home from "./components/Home";
import TheAward from "./components/About";
import Category from "./components/Category";
import Judges from "./components/Judges";
import Judges2022 from "./components/Judges2022";
import Nominees2022 from "./components/2022Nominees";
import Winners2022 from "./components/Winners2022";
import Nominees2023 from "./components/Nominees2023";
import Winners2023 from "./components/Winners2023";
import Blog from "./components/Blog";
import FirstPressRelease from "./components/Blog/components/FirstPressRelease";
import SecondPressRelease from "./components/Blog/components/SecondPressRelease";
import ThirdPressRelease from "./components/Blog/components/ThirdPressRelease";
import FourthRelease from "./components/Blog/components/FourthRelease";
import Gallery from "./components/Gallery";
import Judges2023 from "./components/Judges2023";

const theme = createTheme({
  typography: {
    fontFamily: {
      fontFamily: "Montserrat",
    },
  },
});

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <div className="App">
          <Switch>
            <Route path="/event-gallery" component={Gallery} />
            <Route
              exact
              path="/Call-for-Nominations-Opens-for-the-Active-Citizens-Awards-2026"
              component={FourthRelease}
            />
            <Route
              exact
              path="/budgit-opens-nominations-for-2023-active-citizens-award"
              component={ThirdPressRelease}
            />
            <Route
              exact
              path="/tunde-onakoya-bags-budgit-active-citizens-award"
              component={SecondPressRelease}
            />
            <Route
              exact
              path="/budgit-set-to-host-the-maiden-edition-of-the-active-citizens-awards"
              component={FirstPressRelease}
            />
            <Route exact path="/blog" component={Blog} />
            <Route exact path="/2023-aca-winners" component={Winners2023} />
            <Route
              exact
              path="/2023-shortlisted-nominees"
              component={Nominees2023}
            />
            <Route exact path="/2022-aca-winners" component={Winners2022} />
            <Route
              exact
              path="/2022-shortlisted-nominees"
              component={Nominees2022}
            />
            <Route exact path="/2023-judges" component={Judges2023} />
            <Route exact path="/our-judges" component={Judges} />
            <Route exact path="/2022-judges" component={Judges2022} />
            <Route exact path="/the-award" component={TheAward} />
            <Route exact path="/award-categories" component={Category} />
            <Route exact path="/" component={Home} />
          </Switch>
        </div>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
